import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomePage from '@/features/components/HomePage.vue';
import AboutMe from '@/features/components/AboutMe/AboutMe.vue';
import MyProjects from '@/features/components/MyProjects/MyProjects.vue';
import ContactMe from '@/features/components/ContactMe/ContactMe.vue';
import SkillsPage from '@/features/components/SkillsPage.vue';
import EagleProjectSpec from '@/features/components/MyProjects/EagleProjectSpec.vue';
import WebsiteProjectSpec from './features/components/MyProjects/WebsiteProjectSpec.vue';
import PovoProjectSpec from './features/components/MyProjects/PovoProjectSpec.vue';
import FinalFantasyProjectSpec from './features/components/MyProjects/FinalFantasyProjectSpec.vue';
import ClimbingHoldClassifierSpec from './features/components/MyProjects/ClimbingHoldClassifierSpec.vue';
import ArtHuddle from './features/components/MyProjects/ArtHuddleProject.vue';
import HobbiesInterests from './features/components/AboutMe/HobbiesInterests.vue';

const routes = [
  {
    path: '/',
    component: HomePage
  },
  {
    path: '/about-me',
    component: AboutMe
  },
  {
    path: '/projects',
    component: MyProjects
  },
  {
    path: '/eagle-project',
    component: EagleProjectSpec,
  },
  {
    path: '/rpg-battle-sim',
    component: FinalFantasyProjectSpec,
  },
  {
    path: '/povo-interface',
    component: PovoProjectSpec,
  },
  {
    path: '/my-website',
    component: WebsiteProjectSpec,
  },
  {
    path: '/climbing-hold-classifier',
    component: ClimbingHoldClassifierSpec,
  },
  {
    path: '/art-huddle',
    component: ArtHuddle,
  },
  {
    path: '/interests',
    component: HobbiesInterests,
  },
  {
    path: '/skills-experience',
    component: SkillsPage
  },
  {
    path: '/contact',
    component: ContactMe
  },
  {
    path: '/:catchAll(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes as RouteRecordRaw[],
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router